import React, { useState } from 'react';
import { FaCaretRight } from 'react-icons/fa';
import editIcon from './edit.png';

// --- FUNÇÕES AUXILIARES ATUALIZADAS ---

// ALTERADO: Agora a função entende linhas com e sem links.
const parseContent = (contentString) => {
    if (typeof contentString !== 'string' || contentString.trim() === '') {
        return [];
    }
    return contentString.split('\n').map(line => {
        // Se a linha tem um pipe e um conteúdo depois dele, consideramos um link.
        if (line.includes('|') && line.split('|')[1].trim() !== '') {
            const parts = line.split('|');
            return { text: parts[0], url: parts[1] };
        }
        // Caso contrário, é apenas texto. O 'url' fica nulo.
        return { text: line, url: null };
    });
};

// ALTERADO: Agora a função só adiciona o pipe se a URL existir.
const formatContentForSave = (contentArray) => {
    return contentArray.map(item => {
        if (item.url) {
            return `${item.text}|${item.url}`;
        }
        return item.text; // Salva apenas o texto se não houver URL
    }).join('\n');
};

const Card = ({ id, title, content, buttonText, buttonHref, isAdmin }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [editTitle, setEditTitle] = useState(title);
    const [editContent, setEditContent] = useState(() => parseContent(content));
    const [textButton, setTextButton] = useState(buttonText);
    const [hrefButton, setHrefButton] = useState(buttonHref);

    const apiUrl = process.env.REACT_APP_API_URL;

    const handleContentChange = (index, field, value) => {
        const updatedContent = [...editContent];
        updatedContent[index][field] = value;
        setEditContent(updatedContent);
    };

    const addLink = () => {
        setEditContent([...editContent, { text: '', url: '' }]);
    };

    const removeLink = (index) => {
        const updatedContent = editContent.filter((_, i) => i !== index);
        setEditContent(updatedContent);
    };

    const handleSave = () => {
        const token = localStorage.getItem('token');
        const contentString = formatContentForSave(editContent);

        fetch(`${apiUrl}/api/cards/${id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            body: JSON.stringify({ title: editTitle, content: contentString, buttonText, buttonHref })
        })
            .then(response => response.json())
            .then(() => {
                setIsEditing(false);
                window.location.reload();
            })
            .catch(error => console.error("Erro ao atualizar card:", error));
    };

    const handleEdit = () => {
        setIsEditing(true);
        setEditTitle(title);
        setTextButton(buttonText);
        setHrefButton(buttonHref);
        setEditContent(parseContent(content));
    };

    const showButton = buttonText && buttonHref;

    if (isEditing) {
        return (
            <div className="bg-white py-6 px-12 rounded-lg border-4 border-gray-200 shadow-md flex flex-col">
                <h3 className="text-lg font-semibold mb-2">Título do Card</h3>
                <input className="text-xl border p-2 rounded mb-4" value={editTitle} onChange={(e) => setEditTitle(e.target.value)} />

                <h3 className="text-lg font-semibold mb-2">Conteúdo do Card (Linhas)</h3>
                <div className="space-y-2 mb-4">
                    {editContent.map((item, index) => (
                        <div key={index} className="flex items-center space-x-2 p-2 border rounded">
                            <input
                                placeholder="Texto de exibição"
                                className="border p-2 rounded w-1/2"
                                value={item.text}
                                onChange={(e) => handleContentChange(index, 'text', e.target.value)}
                            />
                            <input
                                placeholder="URL (opcional, deixa a linha clicável)"
                                className="border p-2 rounded w-1/2"
                                value={item.url || ''}
                                onChange={(e) => handleContentChange(index, 'url', e.target.value)}
                            />
                            <button onClick={() => removeLink(index)} className="bg-red-500 text-white px-3 py-2 rounded hover:bg-red-600">X</button>
                        </div>
                    ))}
                </div>
                <button onClick={addLink} className="mb-6 bg-blue-500 text-white px-4 py-2 rounded self-start hover:bg-blue-600">+ Adicionar Linha</button>

                <hr className="my-4" />

                <h3 className="text-lg font-semibold mb-2">Botão no final do Card</h3>
                <input placeholder="Texto do Botão (opcional)" className="border p-2 rounded mb-2" value={textButton} onChange={(e) => setTextButton(e.target.value)} />
                <input placeholder="URL do Botão (opcional)" className="border p-2 rounded mb-6" value={hrefButton} onChange={(e) => setHrefButton(e.target.value)} />

                <button onClick={handleSave} className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition duration-300">Salvar Alterações</button>
            </div>
        );
    }

    return (
        <div className="bg-white pt-6 px-12 rounded-lg border-4 border-gray-200 shadow-md flex flex-col justify-between h-full">
            <div>
                {isAdmin && (
                    <button onClick={handleEdit} className="float-right text-xl"><img src={editIcon} alt='Editar' /></button>
                )}
                <h2 className="text-2xl mt-4 font-bold mb-6">{title}</h2>
                <div className="flex flex-col align-start justify-start mb-6">
                    {editContent.map((item, index) => (
                        <div key={index} className="flex items-center justify-start mb-5 w-full">
                            <FaCaretRight className="text-orange-600 flex-shrink-0" />
                            {item.url ? (
                                <a href={item.url} target="_blank" rel="noopener noreferrer" className="text-lg ml-2 text-gray-800 hover:text-orange-600 hover:underline">{item.text}</a>
                            ) : (
                                <p className="text-lg ml-2 text-gray-800">{item.text}</p>
                            )}
                        </div>
                    ))}
                </div>
            </div>
            {showButton && (
                <div className="-mb-11 mt-auto w-full flex justify-center items-end pb-6">
                    <a href={hrefButton} rel="noopener noreferrer">
                        <button className="bg-orangeColor text-white px-5 py-2 rounded hover:shadow-lg hover:bg-darkOrange transition duration-300">{textButton}</button>
                    </a>
                </div>
            )}
        </div>
    );
};

export default Card;